import { render, staticRenderFns } from "./AnfrageJourney.vue?vue&type=template&id=bf2be966"
import script from "./AnfrageJourney.vue?vue&type=script&lang=js"
export * from "./AnfrageJourney.vue?vue&type=script&lang=js"
import style0 from "./AnfrageJourney.vue?vue&type=style&index=0&id=bf2be966&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports